
document.addEventListener('DOMContentLoaded',function(){
  // Cart count
  function updateCartCount(){
    fetch('/cart.js').then(r=>r.json()).then(cart=>{
      document.querySelectorAll('.cart-count').forEach(el=>{
        el.textContent=cart.item_count;
        el.style.display=cart.item_count>0?'flex':'none';
      });
    }).catch(()=>{});
  }
  updateCartCount();

  // Mobile menu
  var mBtn=document.querySelector('.mobile-menu-btn');
  var mNav=document.querySelector('.mobile-nav');
  var mClose=document.querySelector('.mobile-nav__close');
  if(mBtn&&mNav)mBtn.addEventListener('click',function(){mNav.classList.add('open')});
  if(mClose&&mNav)mClose.addEventListener('click',function(){mNav.classList.remove('open')});

  // Search
  var sBtn=document.querySelector('.search-btn');
  var sMod=document.querySelector('.search-modal');
  var sClose=document.querySelector('.search-modal-close');
  if(sBtn&&sMod)sBtn.addEventListener('click',function(){sMod.classList.add('open');var inp=sMod.querySelector('.search-input');if(inp)inp.focus();});
  if(sClose&&sMod)sClose.addEventListener('click',function(){sMod.classList.remove('open')});
  if(sMod)sMod.addEventListener('click',function(e){if(e.target===sMod)sMod.classList.remove('open')});

  // Qty buttons
  document.querySelectorAll('.qty-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var inp=this.parentElement.querySelector('.qty-input');
      if(!inp)return;
      var v=parseInt(inp.value)||1;
      if(this.dataset.action==='minus')v=Math.max(1,v-1);
      if(this.dataset.action==='plus')v=v+1;
      inp.value=v;
    });
  });

  // Gallery thumbs
  document.querySelectorAll('.product-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      var main=document.querySelector('.product-gallery__main img');
      if(main&&this.dataset.src){
        main.src=this.dataset.src;
        document.querySelectorAll('.product-thumb').forEach(function(x){x.classList.remove('active')});
        this.classList.add('active');
      }
    });
  });

  // Add to cart
  document.querySelectorAll('.add-to-cart-form').forEach(function(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=this.querySelector('.add-to-cart-btn');
      var orig=btn?btn.textContent:'';
      if(btn){btn.textContent='Adding...';btn.disabled=true;}
      fetch('/cart/add.js',{method:'POST',body:new FormData(this)})
        .then(function(r){return r.json()})
        .then(function(){
          updateCartCount();
          if(btn){btn.textContent='Added ✓';setTimeout(function(){btn.textContent=orig;btn.disabled=false;},1500);}
        })
        .catch(function(){if(btn){btn.textContent=orig;btn.disabled=false;}});
    });
  });

  // Cart remove
  document.querySelectorAll('.cart-remove-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var key=this.dataset.key;
      if(!key)return;
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})})
        .then(function(){window.location.reload()});
    });
  });
});
